// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import LearnerLicenseService from '@services/learner-license/index'

export const getConfigurations = createAsyncThunk('learnerLicenseConfiguration/getConfigurations', async (params, { rejectWithValue }) => {
  try {
    const response = await LearnerLicenseService.getLearnerLicenseConfigurations(params)
    return {
      params,
      data: response.data,
      totalPages: response.meta?.itemCount || response.data.length
    }
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const getConfigurationById = createAsyncThunk('learnerLicenseConfiguration/getConfigurationById', async (id, { rejectWithValue }) => {
  try {
    const response = await LearnerLicenseService.getLearnerLicenseConfigurationById(id)
    return response
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const addConfiguration = createAsyncThunk('learnerLicenseConfiguration/addConfiguration', async (configurationData, { rejectWithValue }) => {
  try {
    const response = await LearnerLicenseService.addLearnerLicenseConfiguration(configurationData)
    return response
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const updateConfiguration = createAsyncThunk('learnerLicenseConfiguration/updateConfiguration', async (configurationData, { rejectWithValue }) => {
  try {
    const response = await LearnerLicenseService.updateLearnerLicenseConfiguration(configurationData)
    return response
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const deleteConfiguration = createAsyncThunk('learnerLicenseConfiguration/deleteConfiguration', async (id, { rejectWithValue }) => {
  try {
    await LearnerLicenseService.deleteLearnerLicenseConfiguration(id)
    return id
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const learnerLicenseConfigurationSlice = createSlice({
  name: 'learnerLicenseConfiguration',
  initialState: {
    data: [],
    total: 1,
    params: {},
    selectedConfiguration: null,
    loading: false,
    error: null
  },
  reducers: {
    selectConfiguration: (state, action) => {
      state.selectedConfiguration = action.payload
    },
    clearSelectedConfiguration: (state) => {
      state.selectedConfiguration = null
    }
  },
  extraReducers: (builder) => {
    builder
      // Get configurations list
      .addCase(getConfigurations.pending, (state) => {
        state.loading = true
      })
      .addCase(getConfigurations.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
        state.loading = false
      })
      .addCase(getConfigurations.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })

      // Get configuration by ID
      .addCase(getConfigurationById.fulfilled, (state, action) => {
        state.selectedConfiguration = action.payload
      })

      // Add configuration
      .addCase(addConfiguration.fulfilled, (state, action) => {
        state.data.push(action.payload)
      })

      // Update configuration
      .addCase(updateConfiguration.fulfilled, (state, action) => {
        const index = state.data.findIndex(item => item.id === action.payload.id)
        if (index !== -1) {
          state.data[index] = action.payload
        }
      })

      // Delete configuration
      .addCase(deleteConfiguration.fulfilled, (state, action) => {
        state.data = state.data.filter(item => item.id !== action.payload)
      })
  }
})

export const { selectConfiguration, clearSelectedConfiguration } = learnerLicenseConfigurationSlice.actions

export default learnerLicenseConfigurationSlice.reducer
